import React from 'react'
import {

    ConverToTextComponent,
  } from "./../../../components/UI-Components";
  import Collapse from '@material-ui/core/Collapse';

const getColor = ans => ans === 'correct' ? 'green' : ans === 'wrong' ? 'red' : '#fff';


const OptionComponent = ({ isCorrect, i, option, isMathType }) => {

    const color = getColor(isCorrect)

    return (
        <div className='w-lg-75 w-100' style={{
            marginBottom: 8, border: "1px solid #DDE7F2", width: '75%',
            height: 50, backgroundColor: '#FFFFFF',
            borderRadius: 5, 
            flexDirection: 'row', 
            alignItems: 'center', justifyContent: 'flex-start', marginTop: 4, display: 'flex'
        }}
            
        >
            <div className='mx-4'
                style={{
                    width: 28, height: 28,
                    border: `2px solid ${ color === '#fff' ? '#85D982' : color}`,
                    borderRadius: 100,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff'

                }}>

                <div
                    style={{
                        borderRadius: 100, backgroundColor:color === '#fff' ? '#fff' : color,
                        width: 14, height: 14
                    }}
                />
            </div>
          
        <div className='mx-1' style={{ width: '95%', display: 'flex', flexWrap: 'wrap' }}>
                {/* <h6 isMathType={isMathType} >{option}</h6> */}
                <ConverToTextComponent
                    text={option}
                    color={ color === '#fff' ? '#000' : color}
                    isMathType={isMathType}
                 />
        </div>
        </div>
    )
}


class ResultComponent extends React.Component{
    state={
        collapsed: null
    }
    
  highlightAnswers = (test, i) => {
    return test.correct_option === `option${i}` ? 'correct' : test.correct_option !== `option${i}` && test.user_option === `option${i}` ? 'wrong' : null
  }

    render(){
        const {answers} = this.props;
        return(
            <div>
             {
                answers && answers.length && answers.map((item, index) => {
                    const { question: questionInfo, passage_question, question_id } = item || {};        
                    const { id: passageId } = passage_question || {};
                    const { question, explanation, is_math_type, option1, option2, option3, option4} = questionInfo || {};

                    const option1Color = this.highlightAnswers(item, 1);
                    const option2Color = this.highlightAnswers(item, 2);
                    const option3Color = this.highlightAnswers(item, 3);
                    const option4Color = this.highlightAnswers(item, 4);
                    return(
                        <>
                        <div className='my-2'>
                            <span className='h6'>{`Question  ${index + 1}`}</span>
                        </div>
                        <div className='my-2 py-4 px-4 main' >
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                
                            }}>
                                <ConverToTextComponent
                                    text={question}
                                    isMathType={is_math_type}
                                    fontSize={18}
                                    style={{
                                        width: '100%', 
                                        display: 'flex',
                                        overflow: 'auto',
                                        textAlign:'left',
                                        fontSize: 18, 
                                        color: '#000', 
                                        fontWeight: '700', 
                                        flexWrap: 'wrap' 
                                        }}
                            />
                                {/* <div dangerouslySetInnerHTML={{ __html: question }} 
                                    style={{
                                        width: '100%', 
                                        display: 'flex',
                                        overflow: 'auto',
                                        textAlign:'left',
                                        fontSize: 18, 
                                        color: '#000', 
                                        fontWeight: 'bold', 
                                        flexWrap: 'wrap' 
                                        }}
                                        >
                                </div> */}
            
                            </div>
                            <div className='my-4'>
                                <OptionComponent
                                   isCorrect={option1Color}
                                   i={'a) '}
                                   option={option1}
                                   isMathType={is_math_type}

                                />
                            </div>
                          
                            <div className='my-4'>
                                <OptionComponent 
                                    isCorrect={option2Color}
                                    i={'b) '}
                                    option={option2}
                                    isMathType={is_math_type}
                                />  
                            </div>
                            <div className='my-4'>
                                <OptionComponent 
                                    isCorrect={option3Color}
                                    i={'c) '}
                                    option={option3}
                                    isMathType={is_math_type}
                                />  
                            </div>
                            <div className='my-4'>
                                <OptionComponent 
                                    isCorrect={option4Color}
                                    i={'d) '}
                                    option={option4}
                                    isMathType={is_math_type}
                                />
                            </div>
                            
                            <div
                                  style={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: "space-between",
                                    marginVertical: 0,
                                    flexDirection: "row",
                                  }}
                                >
                                  <div
                                    onClick={() =>
                                      this.setState({
                                        collapsed:
                                          this.state.collapsed ===
                                          (item.question_id ||
                                            item.question_code)
                                            ? null
                                            : item.question_id ||
                                              item.question_code,
                                      })
                                    }
                                  >
                                    <span
                                      style={{ color: "#5400FF", fontSize: 12 }}
                                    >
                                      Explanation
                                    </span>
                                  </div>
                                  {passageId && (
                                    <div
                                      onClick={() => {
                                        this.props.history.push(
                                          "PassageViewer",
                                          {
                                            fromResult: true,
                                            passageId,
                                            question_id,
                                          }
                                        );
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#5400FF",
                                          fontSize: 12,
                                        }}
                                      >
                                        Show Passage
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <Collapse in={(this.state.collapsed === (item.question_id || item.question_code))}  style={{ marginTop: 12 }}>
                                  <div style={{paddingBottom: 10}}>                                    
                                      <ConverToTextComponent text={explanation || '<span> not found </span>'} isMathType={is_math_type} />
                                   
                                       {/* {
                                        !isTestSeries && 
                                        <TouchableOpacity
                                          style={{ marginBottom: 10 }}
                                          onPress={() => {
                                            this.props.navigation.navigate('haveAnIssue', {
                                              subjectId: this.props.userSubjectId,
                                              questionId: item.question_id,
                                              isPlannedTest: this.state._isPlannedTest ? true : false
                                            })
                                            // this.setModalVisible(true);
                                          }}>
                                          <div style={{ flexDirection: 'row', alignItems: 'center' }}>
                                            <Text style={{ color: 'red', marginVertical: 10, fontSize: 10 }}>Have an issue?</Text>
                                            <Create 
                                            // name={'pencil'}
                                            // color={'red'}
                                            //  size={10}
                                              style={{ paddingLeft: 5 , height: 5, width: 5, color: Styles.primaryColor}} />
                                          </div>
                                        </TouchableOpacity>
                                      } */}
                                    </div>
                                  </Collapse>
                            
                       </div> 
                    </>      
                    )
                })
             }
            </div>
        )
    }
}

export default ResultComponent;